export const setUser = (authToken, authKey, data) => {
  localStorage.setItem("token", authToken);
  localStorage.setItem("authkey", authKey);
  localStorage.setItem("user", data);
};

export const getToken = () => {
  const authT = localStorage.getItem("token");
  const authk = localStorage.getItem("authkey");
  const authD = localStorage.getItem("user");
  return { authT, authk, authD };
};

/**
 * Sign a socket in. The server's "connection" event takes the same credentials
 * as the API headers ({ userId, authkey, authtoken }) and answers
 * "unauthorized" without them. Each reconnect is a new socket id that has to
 * sign in again, so it is sent on every connect.
 */
export const signInSocket = (socket) => {
  const send = () => {
    const { authT, authk, authD } = getToken();
    let userId = null;
    try {
      userId = authD ? JSON.parse(authD)._id : null;
    } catch (e) {
      userId = null;
    }
    if (userId && authT && authk) {
      socket.emit("connection", { userId, authkey: authk, authtoken: authT });
    }
  };
  socket.on("connect", send);
  socket.on("unauthorized", (data) => {
    console.warn("Socket sign-in refused:", (data && data.message) || "unauthorized");
  });
  if (socket.connected) send();
};

export const removeUserData = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("authkey");
  localStorage.clear();
};
